import { types as t } from 'mobx-state-tree';
import { AdminExplanationStore } from '../admin-explanation.store';
import {
  AbstractReadingExplanation,
} from '../../../../../question-data-model/Explanation/_extends/reading-explanation.store';

export const AdminReadingExplanationStore = t
  .compose(AbstractReadingExplanation, AdminExplanationStore)
  .named('AdminReadingExplanationStore');
